import { log } from 'console';
import { ILoginRequest } from '../../model/request/auth/ILoginRequest';
import { apiClient } from '../apiClient';
import { apiGuestClient } from '../apiGuestClient';
import { LoginVNPTOIDCRequest } from '../account/AccountModels';

export const authApi = {
    getUser: () => apiClient.get('account/info'),
    logIn: (request: ILoginRequest) => {
        return apiGuestClient.post(`account/login`, request).then((res) => {
            if (res.is_success) {
                return res.data;
            }
        });
    },
    logInVNPT: (request: LoginVNPTOIDCRequest) => {
        return apiGuestClient.post(`account/login-vnpt`, request).then((res) => {
            if (res.is_success) {
                return res.data;
            }
        });
    },
    getUserVNPT: () => apiClient.get('account/info')
};
